// extracted by mini-css-extract-plugin
export default {"fullScreenHeaderContainer":"fullScreenHeaderContainer-C5YuK","cancelButton":"cancelButton-d1uVh","fullScreenHeader":"fullScreenHeader-bVZhd"};